import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import styles from "../notification.module.css";
import { NotificationString } from "./types/translated-strings.types";
import { NotificationStringItem } from "./NotificationStringItem";

interface NotificationTitleProps {
  title: NotificationString;
  read: boolean;
}

export const NotificationTitle = ({ title, read }: NotificationTitleProps) => {
  return (
    <div className={styles["notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      <NotificationStringItem notificationString={title} />
    </div>
  );
};
